<template>
  <div class="skin">
    <div class="title">
      选择服装
      <a class="view-btn" :href="current.evaluation.link.value" target="_self" v-if="current.evaluation.link.value">
        查看测评
      </a>
    </div>
    <div class="skin-list">
      <template v-for="key in Object.keys(dataSource)">
        <div
          class="item"
          :key="key + dataSource[key].icon.value"
          :class="{ active: key === current.key }"
          @click="handleSwitch(key)"
          v-if="dataSource[key].icon.hasValue"
        >
          <img class="icon" alt="" :src="dataSource[key].icon.value" />
          <div class="tag" v-if="dataSource[key].tag.hasValue && dataSource[key].tag.value">
            {{ dataSource[key].tag.value }}
          </div>
          <div class="name">
            {{ dataSource[key].name.value }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    current: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    handleSwitch(key) {
      this.$emit("switch", key);
    }
  }
};
</script>

<style lang="less" scoped>
.skin {
  width: 100%;
  padding: 10px 0;
  // background: #18171e;
  .title {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 400;
    font-size: 12px;
    color: #d4d4d4;
    // line-height: 20px;
    // margin-bottom: 13px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 10px 10px 14px;

    .view-btn {
      position: absolute;
      right: 0;
      top: 10px;
      height: 20px;
      background: rgba(123, 213, 255, 0.3);
      border-radius: 10px;
      color: #82fff8;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      padding: 4px 10px;
      display: flex;
      align-items: center;
    }
  }

  .skin-list {
    display: flex;
    align-items: center;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    /* 滚动槽 */
    &::-webkit-scrollbar {
      width: 4px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #95cde7;
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
    .item {
      flex-shrink: 0;
      position: relative;
      width: 100px;
      height: 164px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 100px;
        object-fit: contain;
      }
      &.active {
        background-color: linear-gradient(
          0deg,
          rgba(255, 195, 32, 0) 0%,
          rgba(255, 195, 32, 0.23) 49%,
          rgba(255, 195, 32, 0) 100%
        );
        background-image: url("~@/assets/zs_imgs/skin-active-bg.png");
        background-size: 115% 100%;
        background-position: center center;
      }

      .tag {
        position: absolute;
        top: 12px;
        right: -8px;
        width: 36px;
        height: 18px;
        background: #1a88dd;
        border-radius: 9px;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 18px;
        text-align: center;
      }

      .name {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
